"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { IconHistory } from "@xefi/x-react/icons";
import { useTranslation } from "react-i18next";
import ImportButton from "./ImportButton";
export default function PaymentsPageHeader() {
  const $ = _c(15);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("paymentsReceived.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1 className="text-xl font-bold uppercase">{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconHistory size={16} />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("paymentsReceived.actions.importsHistory");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Link href="/payments-received/imports" className="flex h-[34px] items-center gap-1.5 rounded-md border border-border px-2.5 text-[13px] transition-colors hover:bg-gray-50 dark:border-zinc-800 dark:hover:bg-zinc-900">{t2}{t3}</Link>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ImportButton />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <div className="flex items-center gap-2">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <div className="mb-6 flex flex-wrap items-center justify-between gap-3">{t1}{t6}</div>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}